import { render, staticRenderFns } from "./pricePainting.vue?vue&type=template&id=b2b65d56&scoped=true"
import script from "./pricePainting.vue?vue&type=script&lang=js"
export * from "./pricePainting.vue?vue&type=script&lang=js"
import style0 from "./pricePainting.vue?vue&type=style&index=0&id=b2b65d56&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b65d56",
  null
  
)

export default component.exports